<template>
  <div class="w-full flex flex-wrap items-center gap-4">
    <div v-for="(legend, index) in legends" :key="index" class="hidden md:flex justify-start px-1">
      <legend-table :legendColor="legend.color" :text="legend.text" />
    </div>

    <div class="flex justify-center">
      <ghost-button
        text="Ver legenda completa"
        width="100%"
        density="compact"
        :prependIcon="mdiMapLegend"
        @click="showAllLegends"
      />
    </div>
  </div>

  <teleport to="#app">
    <legends-modal />
  </teleport>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import LegendTable, { ELegendColor } from '@/components/others/Legend.vue'
import LegendsModal from './legends.modal.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { mdiMapLegend } from '@mdi/js'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { COVERAGE_STATUS_SHORT_LABELS } from '@/utils/coverage'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { useLegendShowsUnidentified } from './useLegendShowsUnidentified'

const modalStore = useModalStore()

const showUnidentified = useLegendShowsUnidentified()

const baseLegends = [
  { text: 'Aberta', color: ELegendColor.alert },
  { text: 'Fixo', color: ELegendColor.default },
  { text: 'Cobertura', color: ELegendColor.warning },
  { text: 'Extra', color: ELegendColor.success }
]

// "Ocupado s/ ident." só quando a resposta conhece o estado (mesma regra da legenda V2).
const legends = computed(() =>
  showUnidentified.value
    ? [
        ...baseLegends,
        {
          text: COVERAGE_STATUS_SHORT_LABELS[CoverageStatus.UNIDENTIFIED],
          color: ELegendColor.unidentified
        }
      ]
    : baseLegends
)

const showAllLegends = () => {
  modalStore.toggleModal(EModals.LEGENDS)
}
</script>
